export default __webpack_public_path__ + "static/media/8.8887dd35.png";